import { Navigate, useLocation } from "react-router-dom";

interface LegacyRedirectProps {
  /** New pathname. The current search, hash and router state carry over. */
  to: string;
}

// Keeps bookmarks and deep links alive after a page changes URL.
export function LegacyRedirect({ to }: LegacyRedirectProps) {
  const { search, hash, state } = useLocation();
  // State too: a feedback restore riding it must reach the new page.
  return <Navigate to={{ pathname: to, search, hash }} state={state} replace />;
}
